import {BaseService, BaseServiceLevel2} from '@/services/base.service'
import store from '@/store/store'
import $utils from '@/utils/utils'
import AppService from '@/services/app.service'
import $const from "@/utils/const";
import $http from "@/plugins/axios";

// List constant for scenario
const NodeType = {
    PROCESS: 'PROCESS',
    DECISION: 'DECISION',
    PORTAL: 'PORTAL',
    SUPPORTER: 'SUPPORTER',
    LINK_SCENARIO: 'LINK_SCENARIO',
    FORM: 'FORM',
    FALLBACK: 'FALLBACK',
    KB: 'KB',
    RE_PROMPT: 'RE_PROMPT'
}

const NodeIconMap = {
    [NodeType.PROCESS]: '/img/scenario/process.svg',
    [NodeType.DECISION]: '/img/scenario/decision.svg',
    [NodeType.PORTAL]: '/img/scenario/portal.svg',
    [NodeType.SUPPORTER]: '/img/scenario/supporter.svg',
    [NodeType.LINK_SCENARIO]: '/img/scenario/link_scenario.svg',
    [NodeType.FORM]: '/img/scenario/process.svg',
    [NodeType.FALLBACK]: '/img/scenario/fallback.svg',
    [NodeType.KB]: '/img/scenario/kb.svg',
    [NodeType.RE_PROMPT]: '/img/scenario/re_prompt.svg',
}

const NodeIconActiveMap = {
    [NodeType.PROCESS]: '/img/scenario/process_active.svg',
    [NodeType.DECISION]: '/img/scenario/decision_active.svg',
    [NodeType.PORTAL]: '/img/scenario/portal_active.svg',
    [NodeType.SUPPORTER]: '/img/scenario/supporter_active.svg',
    [NodeType.LINK_SCENARIO]: '/img/scenario/link_scenario_active.svg',
    [NodeType.FORM]: '/img/scenario/process_active.svg',
    [NodeType.FALLBACK]: '/img/scenario/fallback_active.svg',
    [NodeType.KB]: '/img/scenario/kb_active.svg',
    [NodeType.RE_PROMPT]: '/img/scenario/re_prompt_active.svg',
}

const OperatorType = {
    AND: 'AND',
    OR: 'OR',
    EQUAL: '=',
    GREATER: '>',
    GREATER_EQUAL: '>=',
    LESS: '<',
    LESS_EQUAL: '<=',
    NOT_EQUAL: '!=',
    IN: 'IN',
    NOT_IN: 'NOT_IN',
    CONTAIN: 'CONTAIN',
    NOT_CONTAIN: 'NOT_CONTAIN',
}

const OperatorList = [{text: '=', value: OperatorType.EQUAL}, {text: '>', value: OperatorType.GREATER}, {
    text: '>=', value: OperatorType.GREATER_EQUAL
}, {text: '<', value: OperatorType.LESS}, {text: '<=', value: OperatorType.LESS_EQUAL}, {
    text: '!=', value: OperatorType.NOT_EQUAL
}, {text: 'in', value: OperatorType.IN}, {text: '!in', value: OperatorType.NOT_IN}, {
    text: '⊃', value: OperatorType.CONTAIN
}, {text: '⊅', value: OperatorType.NOT_CONTAIN}]

const CardType = {
    API: 'API', SET_USER_ATTRIBUTE: 'SET_USER_ATTRIBUTE', LUA: 'LUA'
}

const NodeEditorMenuCode = {
    ADD_SETTING: 'ADD_SETTING',
    ADD_NLP_CONFIG: 'ADD_NLP_CONFIG',
    ADD_AUDIO_ENGINE: 'ADD_AUDIO_ENGINE',
    ADD_SET_USER_ATTRIBUTE: 'ADD_JSON',
    ADD_API: 'ADD_API',
    ADD_LUA: 'ADD_LUA',
    CLONE_NODE: 'CLONE_NODE',
    ADD_LLM_CLASSIFIER: 'ADD_LLM_CLASSIFIER'
}

const NodeContextMenuCode = {
    ADD_PROCESS: 'ADD_PROCESS',
    ADD_DECISION: 'ADD_DECISION',
    ADD_PORTAL: 'ADD_PORTAL',
    ADD_SUPPORTER: 'ADD_SUPPORTER',
    ADD_FORM: 'ADD_FORM',
    ADD_FALLBACK: 'ADD_FALLBACK',
    DELETE: 'DELETE',
    LINK_TO: 'LINK_TO',
    LINK_TO_SCENARIO: 'LINK_TO_SCENARIO',
    UNLINK: 'UNLINK',
    FOCUS_NODE: 'FOCUS_NODE',
    KB_NODE: 'KB_NODE',
    COPY_STEP: 'COPY_STEP',
    PASTE_STEP: 'PASTE_STEP'
}

const UserRole = {
    OWNER: 'OWNER', ADMIN: 'ADMIN', EDITOR: 'EDITOR', TESTER: 'TESTER'
}

const ScenarioMode = {
    EDITING: 'EDITING', VIEWING: 'VIEWING'
}

const ScenarioActionsBot = {
    DEBUG: 'DEBUG', MANAGE_PERMISSION: 'MANAGE_PERMISSION', AUDIT: 'AUDIT', ANALYTIC: 'ANALYTIC', HISTORY: 'HISTORY',
}

const TypeBackgroundScenario = {
    GRID: 'GRID', DOTS: 'DOTS',
}

const NodeEditorCopyCode = {
    COPY_ID: 'COPY_ID', COPY_SLUG: 'COPY_SLUG'
}

// List API custom
const StatisticService = {
    getOverview(scenarioId, timeRange) {
        return $http.get(`scenarios/${scenarioId}/statistic/overview/`, {params: timeRange})
    }
}

const NodeService = BaseServiceLevel2('scenarios', 'nodes')
NodeService.addLink = (scenarioId, node1Id, node2Id) => {
    return $http.post(`scenarios/${scenarioId}/nodes/${node1Id}/link/${node2Id}/`)
}
NodeService.deleteLink = (scenarioId, node1Id, node2Id) => {
    return $http.delete(`scenarios/${scenarioId}/nodes/${node1Id}/link/${node2Id}/`)
}

const ScenarioServiceCRUD = BaseService('scenarios')

const UserModeService = BaseServiceLevel2('scenarios', 'user-modes')
UserModeService.search = (scenarioId, params) => {
    return $http.get(`scenarios/${scenarioId}/user-modes/`, {params: params})
}

// ScenarioService
const ScenarioService = {
    // sub services
    VariableService: BaseServiceLevel2('scenarios', 'variables'),
    HistoryService: BaseServiceLevel2('scenarios', 'history'),
    AutomationTestService: BaseServiceLevel2('scenarios', 'testsets'),
    SettingService: BaseServiceLevel2('scenarios', 'settings'),
    UserService: BaseServiceLevel2('scenarios', 'users'),
    DictionaryService: BaseServiceLevel2('scenarios', 'dictionaries'),
    GlobalSettingService: BaseServiceLevel2('scenarios', 'global-settings'),
    ScenarioBackupService: BaseServiceLevel2('scenarios', 'backup'),
    ScenarioAudioService: BaseServiceLevel2('scenarios', 'audios'),
    KbSettingService: BaseServiceLevel2('scenarios', 'kb-settings'),
    AnalysisService: BaseServiceLevel2('scenarios', 'analysis'),
    LLMConfigService: BaseServiceLevel2('scenarios', 'llm-configs'),
    GlobalLUAService: BaseServiceLevel2('scenarios', 'global-luas'),

    CRUD: ScenarioServiceCRUD,
    UserModeService,
    NodeService,
    StatisticService, // constants
    NodeType,
    OperatorType,
    CardType,
    NodeEditorMenuCode,
    NodeContextMenuCode,
    NodeIconMap,
    NodeIconActiveMap,
    OperatorList,
    UserRole,
    ScenarioMode,
    ScenarioActionsBot,
    TypeBackgroundScenario,
    NodeEditorCopyCode, // methods
    ...ScenarioServiceCRUD,
    getScenarioData(id) {
        return $http.get(`/scenarios/${id}/data/`)
    },
    sendMessage(scenarioId, call_id, message, user_attributes = {}, user_attributes_input = {}) {
        let data = null
        let dataPayload = {
            call_id: call_id, message: {
                type: 'payload'
            }, type: 'payload', user_attributes: {
                name: 'test - name', phone: 'test - phone', ...user_attributes,
            }
        }
        switch (message) {
            case $const.MessageTypes.START: {
                data = dataPayload
                data.message.content = 'welcome'
                break
            }
            case $const.MessageTypes.GET_MORE_PROMPT: {
                data = dataPayload
                data.message.content = 'get_more_prompt'
                break
            }
            case $const.MessageTypes.END_CALL: {
                data = dataPayload
                data.type = 'end_call'
                data.message = {content: "", type: "end_call"}
                data.user_attributes = {...user_attributes_input}
                break
            }
            default: {
                data = {
                    'call_id': call_id, 'type': 'text', 'message': {
                        'type': 'text', 'content': message,
                    }, 'user_attributes': {
                        ...user_attributes_input,
                    }
                }
            }
        }

        return $http.post(`/scenarios/${scenarioId}/get-answer-sync/`, data)
    },
    exportScenario() {
        let state = store.state.scenario
        let scenario = state.scenario
        let treeData = state.treeData
        let globalLua = state.globalLua
        globalLua.forEach((item, index) => {
            item.card_index = index
        })
        globalLua.forEach(item => {
            item.lua_code = item.lua_code.script
        })
        let model = {
            scenario: {
                nodes: treeData.nodeList,
                start_node_id: treeData.startId,
                variables: state.variableList,
                dictionaries_tts: state.dictionaryTtsList,
                fallback: scenario.fallback,
                scenario_setting: state.scenario_setting,
                global_setting: state.globalSettingList,
                scenario_audio: state.scenarioAudioList,
                llm_config: state.llmConfigs,
                global_lua: globalLua,
            }
        }
        $utils.downloadJSON(model, scenario.name + ' - Scenario')
    },
    importScenario(scenarioId, formData) {
        return $http.post(`/scenarios/${scenarioId}/import/`, formData)
    },
    isEditable() { // check role edit for all system
        let state = store.state
        let isAdmin = state.user.profile.roles && state.user.profile.roles.includes('admin')
        if (isAdmin) {
            return true
        }

        let role = state.scenario.scenario ? state.scenario.scenario.user_role : ''
        return role === UserRole.OWNER || role === UserRole.EDITOR || role === UserRole.ADMIN
    },
    isEditor() { // check role admin or owner
        let state = store.state
        let role = state.scenario.scenario ? state.scenario.scenario.user_role : ''
        return role === UserRole.EDITOR
    },
    isModeEditing() { // check mode edit on Scenario screen
        let editingUser = store.state.scenario.editing_user
        if (!editingUser) {
            return false
        }
        return editingUser.is_editing

    },
    isAdminOrOwner() {
        let state = store.state
        let isAdmin = state.user.profile.roles && state.user.profile.roles.includes('admin')
        if (isAdmin) {
            return true
        }
        let role = state.scenario.scenario ? state.scenario.scenario.user_role : ''
        return role === UserRole.OWNER || role === UserRole.ADMIN
    },
    speechToText(audioData) {
        let formData = new FormData()
        formData.append('audio', new Blob([audioData]))
        return $http.post('/scenarios/speech-to-text/', formData)
    },
    audit(scenarioId, filter) {
        return $http.get(`/scenarios/${scenarioId}/audit/`, {params: AppService.mapFilterPagination(filter)})
    },
    getCallAudio(callId) {
        let headers = {'use-default-custom': true}
        return $http.get(`/stream-record/${callId}`, {
            responseType: 'blob', headers: headers
        })
    },
    previewAudio(scenarioId, data) {
        return $http.post(`/scenarios/${scenarioId}/preview-audio/`, data, {responseType: 'blob'})
    },
    deleteListNodes(scenarioId, listDelete) {
        return $http.patch(`/scenarios/${scenarioId}/delete-nodes/`, listDelete)
    },
    getNodeSettingVariables() {
        return $http.get(`/node-variables/`)
    },
    getTestSet(scenarioId, groupName) {
        return $http.get(`/scenarios/${scenarioId}/testsets/${groupName}`)
    },
    deleteTestSet(scenarioId, groupName) {
        return $http.delete(`/scenarios/${scenarioId}/delete-testset/${groupName}`)
    },
    getKbMetadata(scenarioId, model) {
        return $http.post(`/scenarios/${scenarioId}/kb-metadata/`, model)
    },
    getAudioEngines() {
        return $http.get(`/audio-engines/`)
    },
    getSystemVariables() {
        return $http.get(`/system-variables/`)
    },
    getFSLog(callId) {
        return $http.get(`/find-log-fs/${callId}/`)
    },
    getCallMonitor(callId) {
        return $http.get(`/find-log-call-monitor/${callId}/`)
    },

    // Guardrail
    rephrasePrompt(scenarioId, data) {
        return $http.post(`/scenarios/${scenarioId}/rephrase-prompt/`, {
            model: data.model || "SaoLa2M-vi-instruct",
            system_prompt: data.sysPrompt || "Dùng tiếng Việt để diễn đạt lại câu input sao cho thật lịch sự, tự nhiên mà vẫn giữ nguyên ý nghĩa gốc.",
            prompt: data.prompt,
            max_tokens: data.maxTokens || 100,
            temperature: data.temperature || 1.0,
            top_p: data.top_p || 0.9,
            n: data.n || 5,
        })
    },
    getDictionaryTemplate(scenarioId) {
        return $http.get(`/scenarios/${scenarioId}/template-dictionary/`, {responseType: 'blob'})
    },
    deleteAllDictionary(scenarioId) {
        return $http.delete(`/scenarios/${scenarioId}/delete-all-dictionary/`)
    },
    importLLMConfig(scenarioId, formData) {
        return $http.post(`/scenarios/${scenarioId}/import-llm-config/`, formData)
    },
}

export default ScenarioService
